import useMutation from "src/hooks/useMutation";

function useImportWarehouseTransfer() {
  return useMutation({
    path: `/api/v1/warehouse-transfers/import`,
    method: "POST",
    // mutateRelatedDataList: {
    //   mutatePath: `/api/v1/warehouse-transfers`,
    //   shouldRevalidate: true,
    // },
  });
}

export default useImportWarehouseTransfer;
